import { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useAuthStore } from '../../../stores/authStore';

interface GuestGuardProps {
  children: ReactNode;
}

/**
 * GuestGuard - Protects routes that should only be accessible to guests
 * Redirects authenticated users to /dashboard
 */
export function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated } = useAuthStore();

  // Redirect to dashboard if authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // Render children if not authenticated
  return <>{children}</>;
}
